export const clientIsReady = typeof window !== 'undefined';
